var map = {
	"./bg.ts": "d5ca",
	"./en.ts": "d1ee",
	"./es.ts": "0029",
	"./it.ts": "75ac",
	"./ja.ts": "ac58",
	"./pt.ts": "1a59",
	"./ru.ts": "39c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "699d";